import { Box, Container } from '@mui/material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  MarkdownText,
  Text,
} from 'ui-kit'
import type { FaqAttributes } from '../../../types/cms'

const Faq = ({ title, faqItems }: FaqAttributes) => {
  const titleLooksLikeMarkdown =
    typeof title === 'string' &&
    (/^\s*#+\s+/.test(title) || title.includes('**'))

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        width: '100%',
        py: 8,
        backgroundColor: 'common.white',
      }}
    >
      <Container maxWidth="lg">
        {titleLooksLikeMarkdown ? (
          <Box
            sx={{
              textAlign: 'center',
              '& h1, & h2, & h3, & h4, & p': {
                m: 0,
              },
            }}
          >
            <MarkdownText>{title}</MarkdownText>
          </Box>
        ) : (
          <Text variant="h2" component="h2" sx={{ textAlign: 'center' }}>
            {title}
          </Text>
        )}
        {faqItems?.map(({ question, answer }) => (
          <Accordion
            key={question}
            showBorder={false}
            fontSize="1.1rem"
            sx={{
              backgroundColor: 'silver.main',
              color: 'primary.main',
              my: 1,
              px: 2,
              py: 1,
            }}
          >
            <AccordionSummary
              aria-controls={`${question}-content`}
              id={`${question}-header`}
              sx={{
                fontSize: '1.1rem',
                '& .MuiAccordionSummary-content': {
                  my: 1,
                },
              }}
            >
              {question}
            </AccordionSummary>
            <AccordionDetails
              sx={{
                fontWeight: 700,
                fontSize: '1.1rem',
                pt: 0,
              }}
            >
              {answer}
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  )
}

export default Faq
